import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import MobileBottomNav from "./components/MobileBottomNav";
import Hero from "./components/Hero";
import InfiniteLogoMarquee from "./components/InfiniteLogoMarquee";
// import DashboardHero from "./components/DashboardHero";
import HowToBuy from "./components/HowToBuy";
import PopupCard from './components/PopupCard';
import PackagesSection from "./components/PackagesSection";
import Faqsection from "./components/Faqsection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import Login from "./components/Login";
import BackToTop from "./components/BackToTop";
import Signup from "./components/Signup";
import ForgotPassword from "./components/ForgotPassword";
import VerifyCode from "./components/VerifyCode";
import ResetPassword from "./components/ResetPassword";
import Dashboardlock from "./components/Dashboardlock";
import Dashboard from "./components/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import ReferrerLink from "./components/ReferrerLink";
import ReferrerCapture from "./components/ReferrerCapture";
import PaymentPage from "./components/PaymentPage";
import PaymentResult from "./components/PaymentResult";
import TransactionHistory from "./components/TransactionHistory";
import Community from "./components/Community";
import Notifications from "./components/Notifications";
import Profile from "./components/Profile";
import PackagesDashboard from "./components/PackagesDashboard";
import ITO from "./components/Ito";
import RoadmapDashboard from "./components/RoadmapDashboard";
import RewardsDashboard from "./components/RewardsDashboard";
import JoinReferral from "./components/JoinReferral";
import Counter from "./components/Counter";
import {
  CookieSettingsPage,
  PrivacyPolicyPage,
  TermsOfServicePage,
} from "./components/LegalPages";
import { X } from "lucide-react";
import SeoManager from "./components/SeoManager";
// import PackageCardComponent from "./components/PackageCardComponent";

function HomePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showSignupModal, setShowSignupModal] = useState(false);

  useEffect(() => {
    const target = location.state?.scrollTarget;
    if (!target) return;

    const handleScroll = () => {
      if (target === "top") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        const section = document.getElementById(target);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }
    };

    handleScroll();
    navigate(location.pathname + location.search + location.hash, { replace: true, state: {} });
  }, [location, navigate]);

  return (
    <>
      {/* <SynergyDashboard /> */}
      {/* <TransactionHistory/> */}
            <PopupCard />

      <Navbar /> {/* desktop nav */}

      <div className="bg-black min-h-screen scroll-smooth relative">
        <Hero />
      
         
        <InfiniteLogoMarquee />
         {/* <section id="roadmap">
          <RoadmapSection />
        </section> */}
        <section id="ITO">
          <ITO />
        </section>
        <section id="about">
          <Dashboardlock />
        </section>
        <section id="how">
          <HowToBuy />
        </section>
       
        <section id="faq">
          <Faqsection />
        </section>
        <CTASection />
        <Footer />
         {/* <PackageCardComponent/> */}
        
        {/* Gift Box Image - Fixed Bottom Right - Clickable */}
        <div 
          className="fixed bottom-12 right-4 z-40 cursor-pointer hover:scale-110 transition-transform duration-200"
          onClick={() => setShowSignupModal(true)}
        >
          <img 
            src="/images/icon-btn.png" 
            alt="Gift Box" 
            className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 object-contain brightness-100 contrast-100"
            style={{ imageRendering: 'crisp-edges' }}
            onError={(e) => {
              e.currentTarget.style.display = 'none';
            }}
          />
        </div>

        {/* Sign Up Modal - only opens when yellow button is clicked */}
        {showSignupModal && (
          <>
            {/* Backdrop blur - full screen overlay */}
            <div 
              className="fixed inset-0 z-[60] bg-black/60 backdrop-blur-sm cursor-pointer"
              onClick={() => setShowSignupModal(false)}
            />

            {/* Popup Card - Centered on screen */}
            <div 
              className="fixed inset-0 z-[70] flex items-center justify-center p-4 pointer-events-none"
              onClick={() => setShowSignupModal(false)}
            >
              <div 
                className="relative w-full max-w-[420px] animate-[scale-in_0.3s_ease-out] rounded-3xl bg-gradient-to-br from-[#2D1B4E] to-[#1A2F5C] p-8 shadow-2xl pointer-events-auto"
                onClick={(e) => e.stopPropagation()}
              >
                {/* Close Button */}
                <button
                  onClick={() => setShowSignupModal(false)}
                  className="absolute right-4 top-4 rounded-full bg-white/10 p-2 text-white transition hover:bg-white/20 hover:rotate-90 duration-300"
                  aria-label="Close popup"
                >
                  <X size={20} />
                </button>

                {/* Video */}
                <div className="flex justify-center mb-6">
                  <video
                    src="/images/Videopopup.mp4"
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="h-48 w-auto object-contain sm:h-56 rounded-lg"
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>

                {/* Content */}
                <div className="text-center">
                  <h2 className="mb-4 text-2xl font-bold sm:text-3xl" style={{ color: '#ECEFF0' }}>
                    Sign up <span style={{ color: '#E5C0FF' }}>NOW</span> and get{" "}
                    <span style={{ color: '#E5C0FF' }}>5000 SCI Token</span>
                  </h2>
                  <p className="text-base sm:text-lg" style={{ color: '#ECEFF0' }}>
                    Join now and receive your welcome bonus!
                  </p>
                </div>

                {/* Sign Up Button */}
                <div className="mt-6">
                  <button
                    onClick={() => {
                      setShowSignupModal(false);
                      navigate("/signup");
                    }}
                    className="w-full rounded-lg bg-gradient-to-r from-[#8C3CDD] to-[#A367FF] py-3 text-base font-semibold text-white shadow-[0_8px_24px_rgba(140,60,221,0.4)] transition hover:shadow-[0_12px_32px_rgba(140,60,221,0.6)] hover:scale-[1.02] active:scale-[0.98]"
                  >
                    Sign up Now
                  </button>
                </div>
              </div>
            </div>

            <style>{`
              @keyframes scale-in {
                from {
                  opacity: 0;
                  transform: scale(0.9);
                }
                to {
                  opacity: 1;
                  transform: scale(1);
                }
              }
            `}</style>
          </>
        )}
      </div>
      <MobileBottomNav />
    </>
  );
}

function PackagesPage() {
  return (
    <>
      <Navbar />
      <div className="bg-black min-h-screen scroll-smooth py-16">
        <section id="listing" className="mx-auto max-w-8xl">
          <PackagesSection />
        </section>
      </div>
      <Footer />
    </>
  );
}

function LegalPage({ children }) {
  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-black">
        {children}
        <Footer />
      </div>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <SeoManager />
      <Routes>
        <Route
          path="/"
          element={<HomePage />}
        />

        <Route path="/login" element={<Login />} /> {/* no Navbar here */}
        <Route path="/signup" element={<Signup/>} /> {/* no Navbar here */}
        <Route path="/forgot-password" element={<ForgotPassword />} /> {/* no Navbar here */}
        <Route path="/forgot-password/verify" element={<VerifyCode />} /> {/* no Navbar here */}
        <Route path="/forgot-password/reset" element={<ResetPassword />} /> {/* no Navbar here */}
        <Route path="/referrer-entry" element={<ReferrerCapture />} /> {/* post-signup */}
        <Route path="/packages" element={<PackagesPage />} />
        <Route path="/counter" element={<Counter />} />
        <Route
          path="/privacy-policy"
          element={
            <LegalPage>
              <PrivacyPolicyPage />
            </LegalPage>
          }
        />
        <Route
          path="/terms-of-service"
          element={
            <LegalPage>
              <TermsOfServicePage />
            </LegalPage>
          }
        />
        <Route
          path="/cookie-settings"
          element={
            <LegalPage>
              <CookieSettingsPage />
            </LegalPage>
          }
        />
        <Route path="/join/:code" element={<JoinReferral />} />
        <Route
          path="/checkout"
          element={
            <ProtectedRoute>
              <PaymentPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment-status"
          element={
            <ProtectedRoute>
              <PaymentResult />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/packages"
          element={
            <ProtectedRoute>
              <PackagesDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/referrer-link"
          element={
            <ProtectedRoute>
              <ReferrerLink />
            </ProtectedRoute>
          }
        />
        <Route
          path="/transactions"
          element={
            <ProtectedRoute>
              <TransactionHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/community"
          element={
            <ProtectedRoute>
              <Community />
            </ProtectedRoute>
          }
        />
        <Route
          path="/roadmap"
          element={
            <ProtectedRoute>
              <RoadmapDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rewards"
          element={
            <ProtectedRoute>
              <RewardsDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <Notifications />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />

      </Routes>
      <MobileBottomNav />
      <BackToTop />
    </Router>
  );
}
